import React from 'react';
import { useTranslation } from 'react-i18next';
import Carousel from '../components/Carousel';
import ServiceCard from '../components/ServiceCard';
import { services } from './ServicesPage';
import HeroSection from '../components/sections/Hero';
import { whyUsPoints } from './AboutPage';

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  const reviews = [
    {
      id: 1,
      name: t('reviews.bilalTitle'),
      review: t('reviews.bilalReview'),
    },
    {
      id: 2,
      name: t('reviews.bassamTitle'),
      review: t('reviews.bassamReview'),
    },
    {
      id: 3,
      name: t('reviews.noufTitle'),
      review: t('reviews.noufReview'),
    },
    {
      id: 4,
      name: t('reviews.emmaTitle'),
      review: t('reviews.emmaReview'),
    },
  ];

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <HeroSection />

      {/* Services Section */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('home.servicesTitle')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('home.servicesSubtitle')}
            </p>
          </div>

          <div className="relative px-4 md:px-12">
            <Carousel
              items={services.map((service) => ({
                id: service.id,
                content: <ServiceCard service={service} />,
              }))}
              type="service"
              customNavigation={true}
            />
          </div>
        </div>
      </section>

      {/* Business Images Carousel */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('home.whyUsTitle')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('home.whyUsSubtitle')}
            </p>
          </div>

          <div className="relative px-4 md:px-12">
            <Carousel
              items={whyUsPoints.map((point) => ({
                id: point.id,
                content: <ServiceCard service={point} />,
              }))}
              type="service"
              customNavigation={true}
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-10">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {t('home.ctaTitle')}
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            {t('home.ctaSubtitle')}
          </p>
          <div className="container mx-auto px-6 py-4">
            <Carousel
              items={reviews}
              type="review"
            />
          </div>
          <a
            className="bg-gradient-to-r from-blue-600/80 to-sky-600/80 hover:from-blue-700 hover:to-sky-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            href="https://wa.me/971503534324"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('home.ctaButton')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
